const GOOGLE_MAPS_URL = 'https://www.google.com/maps/dir/Current+Location/'

export const getGoogleMapsURL = ({ latitude, longitude }) => `${GOOGLE_MAPS_URL}${latitude},${longitude}`

export const getGoogleMapsDirections = ({ address1, city, zipcode }) => `${GOOGLE_MAPS_URL}${address1},${city},${zipcode}`


export const getEmailModalProps = ({
  appointmentId,
  emailDesc,
  emailTitle,
  emailType
}) => ({
  title: emailTitle,
  description: emailDesc,
  requestPayload: {
    type: emailType,
    id: [appointmentId]
  }
})
